import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { siRouterFadeAnimation } from '@simpl/siemens-brand-ng/tools';
import { ConfigService } from './services/config.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventType, EventMessage } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [siRouterFadeAnimation],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  version = '';
  private readonly destroying$ = new Subject<void>();

  constructor(
    private configService: ConfigService,
    private _elementRef: ElementRef,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.configService
      .getConf()
      .subscribe((data) => (this.version = data.app_version));
    this._elementRef.nativeElement.removeAttribute('ng-version');

    // Check if we're on a URL with auth params immediately on load
    const currentUrl = window.location.href;
    const hasAuthParams = currentUrl.includes('code=') || currentUrl.includes('error=') || currentUrl.includes('state=');
    
    // If we have auth params, let MSAL handle them first
    if (hasAuthParams) {
     
    }

    // Clean up URL after MSAL handles redirect
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => 
          msg.eventType === EventType.HANDLE_REDIRECT_END
        ),
        takeUntil(this.destroying$)
      )
      .subscribe(() => {
        // After redirect is handled, navigate to home if URL has auth params
        const url = window.location.href;
        if (url.includes('code=') || url.includes('error=') || url.includes('state=')) {
      
          // Use replaceUrl to avoid adding to browser history
          this.router.navigate(['/'], { replaceUrl: true });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }

  getRouteAnimation(outlet: RouterOutlet) {
    return outlet.isActivated ? outlet.activatedRoute : null;
  }
}